(function () {
  function initGallery(root) {
    var gal = root.querySelector('[data-rx-gallery]');
    if (!gal) return;
    var slides = gal.querySelectorAll('[data-rx-slide]');
    var thumbs = gal.querySelectorAll('[data-rx-thumb]');
    var pos = gal.querySelector('[data-rx-pos]');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== current; });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-on', n === current);
        t.setAttribute('aria-pressed', n === current ? 'true' : 'false');
      });
      if (pos) pos.textContent = current + 1;
      var active = thumbs[current];
      if (active && track) {
        var vertical = track.scrollHeight > track.clientHeight + 1;
        if (vertical) {
          var top = active.offsetTop - track.offsetTop;
          if (top < track.scrollTop) track.scrollTo({ top: top - 8, behavior: 'smooth' });
          else if (top + active.offsetHeight > track.scrollTop + track.clientHeight) track.scrollTo({ top: top + active.offsetHeight - track.clientHeight + 8, behavior: 'smooth' });
        } else {
          active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    }

    // Thumbnail rail: same height as the main photo, with up/down buttons only where there is more to see
    var track = gal.querySelector('[data-rx-rail-track]');
    var up = gal.querySelector('[data-rx-rail="-1"]');
    var down = gal.querySelector('[data-rx-rail="1"]');
    function syncRail() {
      if (!track || !up || !down) return;
      var canScroll = track.scrollHeight > track.clientHeight + 1;
      up.hidden = !canScroll || track.scrollTop <= 2;
      down.hidden = !canScroll || track.scrollTop + track.clientHeight >= track.scrollHeight - 2;
    }
    if (track && up && down) {
      [up, down].forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-rx-rail'), 10);
          track.scrollBy({ top: dir * (track.clientHeight - 60), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', syncRail, { passive: true });
      window.addEventListener('resize', syncRail);
      if ('ResizeObserver' in window) new ResizeObserver(syncRail).observe(track);
      syncRail();
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-rx-thumb'), 10)); });
    });
    var prev = gal.querySelector('[data-rx-prev]');
    var next = gal.querySelector('[data-rx-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    var stage = gal.querySelector('[data-rx-stage]');
    if (!stage) return;

    // Hover zoom (mouse only): follows the cursor across the photo
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    stage.addEventListener('mousemove', function (e) {
      if (!fine.matches || e.target.closest('button')) { stage.classList.remove('is-zoom'); return; }
      var img = slides[current] && slides[current].querySelector('img');
      if (!img) return;
      var r = img.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
      stage.classList.add('is-zoom');
    });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });

    // Swipe between photos on touch screens
    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initEta(root) {
    var el = root.querySelector('[data-rx-eta]');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    var now = new Date();
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var a = addWorkingDays(now, min);
    var b = addWorkingDays(now, max);
    el.textContent = 'estimated arrival ' + fmt(a) + (max > min ? ' – ' + fmt(b) : '');
  }

  function initFloat(root) {
    var bar = root.querySelector('[data-rx-float]');
    var row = root.querySelector('[data-rx-atc-row]');
    if (!bar || !row || !('IntersectionObserver' in window)) return;
    // Show once the main add-to-basket row has scrolled away, hide again while the footer is on screen.
    var past = false, footerIn = false;
    function sync() {
      var show = past && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sync();
    }).observe(row);
    var footer = document.querySelector('.rx-footer, footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerIn = entries[0].isIntersecting;
        sync();
      }).observe(footer);
    }
  }

  function initQty(root) {
    var input = root.querySelector('[data-rx-qty-input]');
    if (!input) return;
    var dec = root.querySelector('[data-rx-qty="-1"]');
    var inc = root.querySelector('[data-rx-qty="1"]');
    var max = parseInt(input.getAttribute('max'), 10) || 10;
    function set(v) {
      v = Math.max(1, Math.min(max, v));
      input.value = v;
      dec.disabled = v <= 1;
      inc.disabled = v >= max;
    }
    dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  }

  function initGrade(root) {
    var btn = root.querySelector('[data-rx-grade-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    });
  }

  function initVariant(root) {
    var select = root.querySelector('[data-rx-variant]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.dataset.url) window.location.href = opt.dataset.url;
    });
  }

  function initChecklist(root) {
    var dialog = root.querySelector('[data-rx-checklist]');
    if (!dialog) return;
    var items = dialog.querySelectorAll('[data-rx-ck]');
    var allBtn = dialog.querySelector('[data-rx-ck-all]');
    var opener = null;

    function setItem(item, open) {
      var btn = item.querySelector('.px-ck__btn');
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
    }
    function syncAll() {
      var all = Array.prototype.every.call(items, function (i) { return i.classList.contains('is-open'); });
      allBtn.textContent = all ? 'Collapse all' : 'Expand all';
    }
    items.forEach(function (item) {
      item.querySelector('.px-ck__btn').addEventListener('click', function () {
        setItem(item, !item.classList.contains('is-open'));
        syncAll();
      });
    });
    allBtn.addEventListener('click', function () {
      var all = Array.prototype.every.call(items, function (i) { return i.classList.contains('is-open'); });
      items.forEach(function (i) { setItem(i, !all); });
      syncAll();
    });

    root.querySelectorAll('[data-rx-checklist-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        opener = btn;
        var id = btn.getAttribute('data-rx-checklist-open');
        items.forEach(function (i) { setItem(i, id && i.getAttribute('data-rx-ck') === id); });
        syncAll();
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
    });
    function close() { dialog.close(); }
    dialog.querySelectorAll('[data-rx-checklist-close]').forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (opener) opener.focus({ preventScroll: true });
    });
  }

  function initQuickView(scope) {
    scope.querySelectorAll('[data-rx-qv-open]').forEach(function (btn) {
      var dialog = document.getElementById(btn.getAttribute('data-rx-qv-open'));
      if (!dialog) return;
      btn.addEventListener('click', function () { dialog.showModal(); });
      dialog.querySelectorAll('[data-rx-qv-close]').forEach(function (b) {
        b.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () { btn.focus({ preventScroll: true }); });
      var form = dialog.querySelector('form');
      if (form) form.addEventListener('submit', function () { setTimeout(function () { dialog.close(); }, 50); });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rx-product]').forEach(function (root) {
      // The script is included by more than one section; set each product up once,
      // otherwise toggles (checklist rows, grade panel) get two handlers and cancel out.
      if (root.dataset.rxReady) return;
      root.dataset.rxReady = '1';
      initGallery(root);
      initQty(root);
      initGrade(root);
      initVariant(root);
      initChecklist(root);
      initEta(root);
      initFloat(root);
    });
  }

  window.RebxQuickView = initQuickView;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
